var _defs, _rect, _rect2, _circle, _text, _text2, _rect3, _text3, _path, _rect4, _text4, _rect5, _circle2, _text5, _text6, _rect6, _circle3, _text7, _text8, _rect7, _circle4, _text9, _text0, _rect8, _circle5, _text1, _text10, _rect9, _text11, _text12, _text13, _rect0, _rect1, _text14, _text15, _rect10, _rect11, _text16, _text17, _rect12, _rect13, _rect14, _text18, _text19, _text20, _text21, _text22, _rect15, _rect16, _text23, _text24, _text25, _rect17, _rect18, _text26, _text27, _text28, _rect19, _rect20, _text29, _text30, _rect21, _text31, _text32, _text33, _text34, _circle6, _text35, _text36, _text37, _text38, _circle7, _text39, _circle8, _text40, _text41, _text42, _text43, _circle9, _text44, _circle0, _text45, _text46, _text47, _text48, _circle1, _text49, _circle10, _text50, _text51, _text52, _text53, _circle11, _text54;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportCommandCentreWorkforceReadinessDashboardDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1440,
    height: 840,
    viewBox: "0 0 1440 840",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Work Passport workforce readiness command centre dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wp-cc-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF3FD"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "wp-cc-shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 16,
    stdDeviation: 24,
    floodColor: "#020716",
    floodOpacity: 0.18
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 1400,
    height: 800,
    rx: 38,
    fill: "url(#wp-cc-bg)",
    stroke: "#29405D",
    filter: "url(#wp-cc-shadow)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 50,
    width: 1336,
    height: 76,
    rx: 18,
    fill: "#07152A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 88,
    r: 8,
    fill: "#30D6A1"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 83,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 850
  }, "Workforce readiness")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 105,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 650
  }, "All active sites \xB7 Live view")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1036,
    y: 68,
    width: 160,
    height: 42,
    rx: 12,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 1054,
    y: 94,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 760
  }, "All sites")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1172 84l7 7 7-7",
    fill: "none",
    stroke: "#74BDFF",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1210,
    y: 68,
    width: 154,
    height: 42,
    rx: 12,
    fill: "#087CFF"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 1230,
    y: 94,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "Export report")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 150,
    width: 310,
    height: 126,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 180,
    r: 6,
    fill: "#087CFF"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 230,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 42,
    fontWeight: 880
  }, "486")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 256,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820,
    letterSpacing: 1
  }, "TOTAL WORKFORCE")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 150,
    width: 310,
    height: 126,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 414,
    cy: 180,
    r: 6,
    fill: "#30D6A1"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 410,
    y: 230,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 42,
    fontWeight: 880
  }, "412")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 410,
    y: 256,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820,
    letterSpacing: 1
  }, "READY")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 150,
    width: 310,
    height: 126,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 748,
    cy: 180,
    r: 6,
    fill: "#F5B642"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 744,
    y: 230,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 42,
    fontWeight: 880
  }, "48")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 744,
    y: 256,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820,
    letterSpacing: 1
  }, "EXPIRING SOON")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1054,
    y: 150,
    width: 310,
    height: 126,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1082,
    cy: 180,
    r: 6,
    fill: "#FF6B67"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 1078,
    y: 230,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 42,
    fontWeight: 880
  }, "26")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 1078,
    y: 256,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820,
    letterSpacing: 1
  }, "ACTION REQUIRED")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 302,
    width: 510,
    height: 246,
    rx: 22,
    fill: "#07152A"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 344,
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "SITE READINESS")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 386,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 740
  }, "North Processing Plant")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 386,
    textAnchor: "end",
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 850
  }, "92%")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 401,
    width: 450,
    height: 7,
    rx: 3.5,
    fill: "#203854"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 401,
    width: 414,
    height: 7,
    rx: 3.5,
    fill: "#30D6A1"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 439,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 740
  }, "East Shaft")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 439,
    textAnchor: "end",
    fill: "#F5B642",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 850
  }, "78%")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 454,
    width: 450,
    height: 7,
    rx: 3.5,
    fill: "#203854"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 454,
    width: 351,
    height: 7,
    rx: 3.5,
    fill: "#F5B642"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 492,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 740
  }, "West Works")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 492,
    textAnchor: "end",
    fill: "#FF6B67",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 850
  }, "63%")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 507,
    width: 450,
    height: 7,
    rx: 3.5,
    fill: "#203854"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 507,
    width: 284,
    height: 7,
    rx: 3.5,
    fill: "#FF6B67"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 584,
    y: 302,
    width: 804,
    height: 246,
    rx: 22,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 614,
    y: 344,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "UPCOMING EXPIRIES")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 614,
    y: 386,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 820
  }, "Programmes requiring action")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 614,
    y: 422,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "First Aid")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 930,
    y: 422,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700
  }, "14 people")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 1170,
    y: 422,
    fill: "#F5B642",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "30\u201360 days")), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1234,
    y: 412,
    width: 120,
    height: 9,
    rx: 4.5,
    fill: "#EAF3FD"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1234,
    y: 412,
    width: 70,
    height: 9,
    rx: 4.5,
    fill: "#F5B642"
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 614,
    y: 461,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "Working at Heights")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 930,
    y: 461,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700
  }, "9 people")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 1170,
    y: 461,
    fill: "#FF6B67",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "0\u201330 days")), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1234,
    y: 451,
    width: 120,
    height: 9,
    rx: 4.5,
    fill: "#EAF3FD"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1234,
    y: 451,
    width: 48,
    height: 9,
    rx: 4.5,
    fill: "#FF6B67"
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 614,
    y: 500,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "Legal Liability")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 930,
    y: 500,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700
  }, "21 people")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 1170,
    y: 500,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "60\u201390 days")), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1234,
    y: 490,
    width: 120,
    height: 9,
    rx: 4.5,
    fill: "#EAF3FD"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1234,
    y: 490,
    width: 105,
    height: 9,
    rx: 4.5,
    fill: "#087CFF"
  })), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 596,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "EMPLOYEE READINESS")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 1366,
    y: 596,
    textAnchor: "end",
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 760
  }, "Updated 07:42")), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 614,
    width: 1336,
    height: 166,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 126,
    y: 646,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 1
  }, "EMPLOYEE")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 446,
    y: 646,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 1
  }, "SITE")), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 770,
    y: 646,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 1
  }, "POSITION")), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 1226,
    y: 646,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 1
  }, "STATUS")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 669,
    r: 12,
    fill: "#30D6A1",
    fillOpacity: 0.14
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 673,
    textAnchor: "middle",
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 8,
    fontWeight: 850
  }, "TM")), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 126,
    y: 674,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 780
  }, "Thabo Mokoena")), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 446,
    y: 674,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 680
  }, "North Processing Plant")), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 770,
    y: 674,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 680
  }, "Maintenance Technician")), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1228,
    cy: 669,
    r: 5,
    fill: "#30D6A1"
  })), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 1244,
    y: 674,
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "READY")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 700,
    r: 12,
    fill: "#F5B642",
    fillOpacity: 0.14
  })), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 704,
    textAnchor: "middle",
    fill: "#F5B642",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 8,
    fontWeight: 850
  }, "LN")), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 126,
    y: 705,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 780
  }, "Lerato Nkosi")), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 446,
    y: 705,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 680
  }, "East Shaft")), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 770,
    y: 705,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 680
  }, "Plant Operator")), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1228,
    cy: 700,
    r: 5,
    fill: "#F5B642"
  })), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 1244,
    y: 705,
    fill: "#F5B642",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "18 DAYS")), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 731,
    r: 12,
    fill: "#FF6B67",
    fillOpacity: 0.14
  })), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 735,
    textAnchor: "middle",
    fill: "#FF6B67",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 8,
    fontWeight: 850
  }, "SM")), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    x: 126,
    y: 736,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 780
  }, "Sipho Maseko")), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    x: 446,
    y: 736,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 680
  }, "West Works")), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    x: 770,
    y: 736,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 680
  }, "Shift Supervisor")), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 1228,
    cy: 731,
    r: 5,
    fill: "#FF6B67"
  })), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    x: 1244,
    y: 736,
    fill: "#FF6B67",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "ACTION")), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 762,
    r: 12,
    fill: "#30D6A1",
    fillOpacity: 0.14
  })), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 766,
    textAnchor: "middle",
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 8,
    fontWeight: 850
  }, "ND")), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    x: 126,
    y: 767,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 780
  }, "Nomsa Dlamini")), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    x: 446,
    y: 767,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 680
  }, "North Processing Plant")), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    x: 770,
    y: 767,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 680
  }, "Safety Officer")), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1228,
    cy: 762,
    r: 5,
    fill: "#30D6A1"
  })), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    x: 1244,
    y: 767,
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "READY")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportCommandCentreWorkforceReadinessDashboardDesktop);
export default __webpack_public_path__ + "static/media/work-passport-command-centre-workforce-readiness-dashboard-desktop.2a6f2fd8c3a233a22e8f12065934692f.svg";
export { ForwardRef as ReactComponent };